import { useQuery } from '@tanstack/react-query';
import { Button } from '@upme/ui/components/button';
import { Checkbox } from '@upme/ui/components/checkbox';
import { type ChangeEvent, useRef, useState } from 'react';
import { useDeleteImage, useUpdateCityConfig, useUpdateImage, useUploadImage } from '../mutations';
import { morningCityConfigOptions, morningImagesOptions } from '../queries';
import { CityScopeSelect } from './city-scope-select';

export function MorningImagesTab() {
  const [scope, setScope] = useState('global');
  const cityId = scope === 'global' ? null : scope;
  const { data: images = [] } = useQuery(morningImagesOptions(scope));
  const upload = useUploadImage();
  const update = useUpdateImage();
  const del = useDeleteImage();
  const fileRef = useRef<HTMLInputElement>(null);

  const onFile = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) upload.mutate({ file, cityId });
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <div className="space-y-4 p-4">
      <CityScopeSelect value={scope} onChange={setScope} />
      {cityId && <CityImagePoolToggle cityId={cityId} />}
      <div>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={onFile} />
        <Button onClick={() => fileRef.current?.click()} disabled={upload.isPending}>
          {upload.isPending ? 'Загрузка…' : 'Загрузить картинку'}
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
        {images.map((img) => (
          <div key={img.id} className="space-y-2 rounded border p-2">
            <img src={img.url} alt={img.label ?? ''} className="aspect-video w-full rounded object-cover" />
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-xs">
                <Checkbox
                  checked={img.isActive}
                  onCheckedChange={(v) => update.mutate({ id: img.id, body: { isActive: Boolean(v) } })}
                />
                <span>Активна</span>
              </div>
              <span className="text-xs text-muted-foreground">{img.cityId ? 'город' : 'общее'}</span>
            </div>
            <Button variant="ghost" size="sm" className="w-full" onClick={() => del.mutate(img.id)}>
              Удалить
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}

function CityImagePoolToggle({ cityId }: { cityId: string }) {
  const { data } = useQuery(morningCityConfigOptions(cityId));
  const update = useUpdateCityConfig(cityId);
  if (!data) return null;
  return (
    <div className="flex items-center gap-2 text-sm">
      <Checkbox
        checked={data.useGlobalImages}
        onCheckedChange={(v) => update.mutate({ useGlobalImages: Boolean(v) })}
      />
      <span>Использовать глобальные картинки вместе с городскими</span>
    </div>
  );
}
